import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { RoleNames } from '../../constants/role-names';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
const misc: any = {
  sidebar_mini_active: true,
};

// Metadata
export interface RouteInfo {
  path: string;
  title: string;
  type: string;
  collapse?: string;
  icontype: string;
  // icon: string;
  children?: ChildrenItems[];
}

export interface ChildrenItems {
  path: string;
  title: string;
  ab: string;
  type?: string;
}

// Menu Items

export const ADMINUPPERROUTES: RouteInfo[] = [
  // {
  //   path: '/dashboard/profile',
  //   title: 'Profile',
  //   type: 'link',
  //   icontype: 'fas fa fa-user',
  // },
];
export const MERCHUPPERROUTES: RouteInfo[] = [

];

export const ADMINROUTES: RouteInfo[] = [
  {
    path: '/dashboard/home',
    title: 'Dashboard',
    type: 'link',
    icontype: 'fas fa-home',
  },
  {
    path: '/dashboard',
    title: 'User',
    type: 'sub',
    icontype: 'fas fa-user-friends',
    collapse: 'Settings',
    children: [
      {
        path: '/customer',
        title: 'Customer',
        type: 'link',
        ab: 'fas fa-hand-holding-usd',
      },
      {
        path: '/merchant',
        title: 'Merchant',
        type: 'link',
        ab: 'fas fa-people-carry',
      },

      // {path: '/merchant-detail', title: 'Merchant Info', type: 'link', ab: 'fa fa-user-secret'},
      //  {path: '/shop-setting', title: 'Shop setting', type: 'link', ab: 'fas fa-store-alt'},
    ],
  },
  {
    path: '/dashboard/aminity',
    title: 'Amenity Template',
    type: 'link',
    icontype: 'fas fa-star-half-alt',
  },
  {
    path: '/dashboard/reviews',
    title: 'Reviews',
    type: 'link',
    icontype: 'fas fa-star-half-alt',
  },
  {
    path: '/dashboard/province',
    title: 'Province',
    type: 'link',
    icontype: 'fas fa-globe-americas',
  },
  {
    path: '/dashboard/cities',
    title: 'Cities',
    type: 'link',
    icontype: 'fas fa-city',
  },
  {
    path: '/dashboard/business-type',
    title: 'Business Types',
    type: 'link',
    icontype: 'fas fa-laptop-house',
  },
  {
    path: '/dashboard/membership',
    title: 'Membership',
    type: 'link',
    icontype: 'fas fa-users',
  },
  {
    path: '/dashboard/notification',
    title: 'Notifications',
    type: 'link',
    icontype: 'far fa-bell',
  },
  // {
  //   path: '/dashboard/settings',
  //   title: 'Settings',
  //   type: 'link',
  //   icontype: 'fas fa-cogs',
  // },

  {
    path: '/logout',
    title: 'Logout',
    type: 'link',
    icontype: 'fas fa fa-sign-out-alt',
  },
];

export const MERCHANTROUTES: RouteInfo[] = [
  {
    path: '/dashboard/home-merch',
    title: 'Dashboard',
    type: 'link',
    icontype: 'fas fa-columns',
  },
  {
    path: '/dashboard/reviews',
    title: 'Reviews',
    type: 'link',
    icontype: 'fas fa-star-half-alt',
  },
  {
    path: '/dashboard/notification',
    title: 'Notifications',
    type: 'link',
    icontype: 'far fa-bell',
  },

  {
    path: '/dashboard/query',
    title: 'Query',
    type: 'link',
    icontype: 'far fa-question-circle',
  },


  {
    path: '/dashboard/settings',
    title: 'Settings',
    type: 'link',
    icontype: 'fas fa-cogs',
  },



  {
    path: '/logout',
    title: 'Logout',
    type: 'link',
    icontype: 'fas fa fa-sign-out-alt',
  },
];

@Component({
  selector: 'app-sidebar',
  templateUrl: 'sidebar.component.html',
  styleUrls: ['sidebar.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class SidebarComponent implements OnInit {
  public static Routes: RouteInfo[];
  currentRoutes: RouteInfo[];
  upperMenuRoutes: RouteInfo[];
  isAdmin = false;

  constructor(
    private authService: AuthService,
    private matIconReg: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {}

  isNotMobileMenu() {
    return window.outerWidth <= 991;
  }

  ngOnInit() {

    if (this.authService.isRole(RoleNames.Administrator)) {
      this.isAdmin = true;
      this.currentRoutes = ADMINROUTES.filter(() => true);
      this.upperMenuRoutes = ADMINUPPERROUTES.filter(() => true);
      for (let i = 0; i < ADMINROUTES.length; i++) {
        this.matIconReg.addSvgIcon(
          this.currentRoutes[i].title,
          this.domSanitizer.bypassSecurityTrustResourceUrl(
            this.currentRoutes[i].icontype
          )
        );
      }
    }
    if (this.authService.isRole(RoleNames.Merchant)) {
      this.currentRoutes = MERCHANTROUTES.filter(() => true);
      this.upperMenuRoutes = MERCHUPPERROUTES.filter(() => true);
      for (let i = 0; i < MERCHANTROUTES.length; i++) {
        this.matIconReg.addSvgIcon(
          this.currentRoutes[i].title,
          this.domSanitizer.bypassSecurityTrustResourceUrl(
            this.currentRoutes[i].icontype
          )
        );
      }
    }

    SidebarComponent.Routes = this.currentRoutes.filter(() => true);
  }

  getProfileImage(): string {
    return this.authService.currentUser.image;
  }

  getProfileName(): string {
    return this.authService.currentUser.fullName[0];
  }

  minimizeSidebar() {
    const body = document.getElementsByTagName('body')[0];
    if (body.classList.contains('sidebar-mini')) {
      misc.sidebar_mini_active = true;
    } else {
      misc.sidebar_mini_active = false;
    }
    if (misc.sidebar_mini_active === true) {
      body.classList.remove('sidebar-mini');
      misc.sidebar_mini_active = false;
    } else {
      body.classList.add('sidebar-mini');
      misc.sidebar_mini_active = true;
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }
}
